import axios from "axios";
import { BE_SERVER_ENDPOINT, API_PROTOCOL } from "../constants/configs.js";
import { TRANSLATION_ACTIONS } from "../actions/translationActions";

const TranslationDataFetcher = {
  fetchAllTranslations: function(options) {
    return dispatch => {
      let url = API_PROTOCOL + BE_SERVER_ENDPOINT + "/2.1/stringResources/pilot/" + options.pilotId + "?locale=" + options.locale + "&tag=ui";
      if (options.module) {
        url += "&module=" + options.module;
      }
      axios.get(url)
        .then(response => {
          dispatch({
            type: TRANSLATION_ACTIONS.FETCH_ALL_TRANSLATIONS_DATA_SUCCESS,
            payload: response.data.payload
          });
        });
    };
  }
};

export default TranslationDataFetcher;
